module.exports = __webpack_public_path__ + "static/media/open_editor.710e9ab0.svg";